export const ERROR_PAYLOAD_STORAGE_KEY = 'app_error_payload';

type SavePayload = {
  message: string;
  stack?: string;
  componentStack?: string;
  originPath?: string;
  source?: string;
  metadata?: Record<string, unknown>;
  timestamp?: number;
};

export type ErrorPayload = SavePayload & { timestamp: number };

const canUseSessionStorage = () => typeof window !== 'undefined' && !!window.sessionStorage;

export const saveErrorPayload = (payload: SavePayload) => {
  if (!canUseSessionStorage()) return;
  try {
    const data: ErrorPayload = {
      timestamp: payload.timestamp ?? Date.now(),
      ...payload,
    };
    window.sessionStorage.setItem(ERROR_PAYLOAD_STORAGE_KEY, JSON.stringify(data));
  } catch {}
};

export const consumeErrorPayload = (): ErrorPayload | null => {
  if (!canUseSessionStorage()) return null;
  try {
    const raw = window.sessionStorage.getItem(ERROR_PAYLOAD_STORAGE_KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(ERROR_PAYLOAD_STORAGE_KEY);
    return JSON.parse(raw) as ErrorPayload;
  } catch {
    return null;
  }
};
